export default "__VITE_ASSET__f52Q3yNg__"